import withUser from '../components/HOC/withUser';

const Live = () => {
  return <div>hello</div>;
};

export default withUser(Live);
